export function isDevelopment(){
    return location.host.startsWith('localhost') && location.host !=='localhost:49999'
}